import './about.css';
import daddu from '../assets/daddu.jpg';
import about from '../assets/aboutus.jpg';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import Nav from './Nav';

export default function About() {
  return (
    <>
      <Nav />
      <Navbar />
      <div className="about-wrapper">
        {/* Top Banner */}
        <section className="booksto-banner">
          <div className="banner-overlay"></div>
        </section>

        {/* Side Glows */}
        <div className="side-decor decor-left"></div>
        <div className="side-decor decor-right"></div>

        {/* Author Section */}
        <motion.div
          className="about-section glass"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="author-img-container">
            <motion.img
              src={daddu}
              alt="Author"
              className="author-img"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ type: 'spring', stiffness: 80, damping: 10 }}
            />
          </div>
          <div className="author-content">
            <h2>About the Founder</h2>
            <p>
              Pandit Satish Chandra Srivastava, born on 8th September 1938 in Allahabad, Uttar Pradesh,
              was a distinguished sitarist and music educator. He began his sitar training under Prof. Banwari
              Lal and, from 1963, honed his craft under the tutelage of Sitar maestro Pt. Ravi Shankar. His
              academic career spanned nearly four decades as a faculty member and later Head of the
              Department of Music at D.G.P.G. College, Kanpur (1960–1999). Recognized as a “Top Grade
              Artist” by All India Radio and Doordarshan, he performed on prestigious stages worldwide and
              conducted numerous workshops to promote Hindustani Classical Music. Honoured with titles
              such as Sangeetacharya, Sangeet Kala Ratna, Sangeet Shiromani, and the Sangeet Natak
              Akademi Award, his contributions were also featured in esteemed journals like Sangeet Kala
              Vihar and Sangeet. He authored numerous books to pass on his knowledge for the benefit of
              future generations. In 2024, a research thesis titled “Pandit Satish Chandra Srivastava Ka
              Sangeet Ke Kshetra Mein Yogdan” was documented at Punjab University, highlighting his
              significant impact on Indian Classical Music.
            </p>
          </div>
        </motion.div>
       <motion.div
  className="about-section glass reverse-layout"
  initial={{ opacity: 0, y: 60 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
>
  <div className="author-content">
    <h2>About Us</h2>
    <p>
      At Sangeet Shree Prakashan, we are passionate about preserving and promoting the rich
      tradition of Hindustani Classical Music through authentic, syllabus-oriented publications.
      Established with a deep respect for India’s musical heritage, our goal is to make classical music
      education accessible, simple, and enjoyable for students, teachers, and enthusiasts alike.
      We specialize in publishing music books in languages like Hindi and English, crafted
      meticulously to align with academic syllabuses, yet designed to foster a genuine appreciation of
      the art form beyond examinations. Every book we publish is a reflection of our commitment to
      authenticity, quality, and cultural responsibility.
      <br /><br />
      Our mission goes beyond just providing study material. We aim to bridge the gap between
      traditional music knowledge and modern learning needs, ensuring that learners not only acquire
      technical proficiency but also understand the spiritual depth and beauty of Hindustani Classical
      Music.
      Over the years, Sangeet Shree Prakashan has earned the trust of students, educators, and
      institutions as a reliable source for well-structured, easy-to-understand music books. Our vision
      is to nurture a new generation of musicians who cherish classical music as a lifelong passion,
      not merely a subject for exams.
      We believe that music education should be an enriching journey—one that connects learners to
      India’s rich cultural roots while preparing them for academic excellence.
      <br /><br />
      Join us in our mission to keep the timeless art of Hindustani Classical Music alive, accessible,
      and thriving for generations to come.
    </p>
  </div>
  <div className="author-img-container">
    <motion.img
      src={about}
      alt="Author"
      className="author-img"
      initial={{ scale: 0 }}
      whileInView={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 80, damping: 10 }}
    />
  </div>
</motion.div>

      </div>
      <Footer />
    </>
  );
}
